// extracted by mini-css-extract-plugin
module.exports = {"subscribe_main":"subscribe_subscribe_main__ea9yI","h4":"subscribe_h4__8V_bl","form_input":"subscribe_form_input__mF8cH","btn_get_started1":"subscribe_btn_get_started1__h1JcW"};